import React from 'react';
import type { Optional } from '@gov-nx/core/types';
import { stripHTMLTagsAndGetParagraphs } from '@gov-nx/utils/common';

interface EPetitionPerexProps {
	perex: Optional<string>;
	className?: string;
}

export const EPetitionPerex = ({ perex, className }: EPetitionPerexProps) => {
	const leads = perex ? stripHTMLTagsAndGetParagraphs(perex) : [];

	if (!leads.length) return null;

	return (
		<span className={className}>
			{leads.map((line, index) => (
				<React.Fragment key={line}>
					{line}
					{index < leads.length - 1 && <br />}
				</React.Fragment>
			))}
		</span>
	);
};
